module.exports = __webpack_public_path__ + "static/img/ezn-foundation.41c857a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ezn-foundation.jpg
// module id = geRr
// module chunks = 0